import { Provider, REQUEST, REQUEST_CONTEXT } from '@angular/core';

const browserResponse = {
  statusCode: 200,
  hostname: window.location.hostname,
  headers: {
    get: (name: string) => {
      const headers: { [key: string]: string } = {
        'x-forwarded-host': window.location.hostname,
        'user-agent': navigator.userAgent,
      };
      return headers[name] || null;
    },
  },
};

export const withBrowserProviders = (): Provider[] => {
  return [
    {
      provide: REQUEST_CONTEXT,
      useValue: browserResponse,
    },
    {
      provide: REQUEST,
      useValue: browserResponse,
    },
  ];
};
